import React, {useEffect, useState} from 'react';
import Box from '../Box';
import {setSmsOptOutProcessed} from '../../reducer';
import {connect} from 'react-redux';

const OPT_OUT_STATE = {
  none: 0,
  processing: 1,
  processed: 2
};

function SmsOptOut({setSmsOptOutProcessed, optOutProcessed, text = 'Liever geen sms? Klik hier om je af te melden', processedText = 'We hebben je afgemeld voor sms'}) {
  const urlParams = new URLSearchParams(window.location.search);
  const [processOptOut, setProcessOptOut] = useState(OPT_OUT_STATE.none);

  useEffect(() => {
    if (optOutProcessed) {
      setProcessOptOut(OPT_OUT_STATE.processed);
    }
  }, [optOutProcessed]);

  useEffect(() => {
    if (processOptOut !== OPT_OUT_STATE.processing) {
      return;
    }

    const controller = new AbortController();
    const signal = controller.signal;

    fetch('/api/optout', {
      signal,
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        contactMoment: urlParams.get('dm_cm'),
        optout: 'sms'
      })
    })
      .then((r) => {
        setSmsOptOutProcessed();
      })
      .catch(() => {
        alert('Er is iets mis gegaan');
        setProcessOptOut(OPT_OUT_STATE.none);
      });

    return () => {
      controller.abort();
    };
  }, [processOptOut]);

  if (!urlParams.has('dm_cm')) {
    return null;
  }

  if (!urlParams.has('dm_sou')) {
    return null;
  }

  const optOut = e => {
    e.preventDefault();
    e.stopPropagation();

    setProcessOptOut(OPT_OUT_STATE.processing);
  };

  return <div style={{paddingTop: '1rem'}}>
    <Box>
      <div style={{padding: '1rem'}}>
        {processOptOut === OPT_OUT_STATE.none && <a href='#' onClick={optOut}>{text}</a>}
        {processOptOut === OPT_OUT_STATE.processing && 'Even geduld...'}
        {processOptOut === OPT_OUT_STATE.processed && processedText}
      </div>
    </Box>
  </div>;
}

export default connect(state => ({
  optOutProcessed: state.reducer.SMS_OPT_OUT_PROCESSED
}), dispatch => ({
  setSmsOptOutProcessed: () => {
    dispatch(setSmsOptOutProcessed());
  }
}))(SmsOptOut);
